import React from 'react';
import { Form } from 'formik';
import { Col, Row } from 'reactstrap';
import S3FileUploadField from 'components/S3FileUploadField';
import EditUploadDownloadWrapper from 'components/EditUploadDownloadWrapper';
import LoadingButton from 'components/common/LoadingButton';

const VendorKycForm = (props) => {
  const { handleSubmit, isSubmitting, isValid, dirty, values, setFieldValue } =
    props;

  const downloadImage = async (imageUrl, imageName) => {
    if (!imageUrl) return '';

    try {
      const response = await fetch(imageUrl);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = imageName || 'document';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error downloading image:', error);
      // Fallback for CORS or other fetch issues
      window.open(imageUrl, '_blank');
    }
  };

  const aadharFrontImage = values?.aadharFront
    ? values?.aadharFront.split('/')
    : values?.aadharFront;
  const aadharBackImage = values?.aadharBack
    ? values?.aadharBack.split('/')
    : values?.aadharBack;
  const panCardImage = values?.panPhoto
    ? values?.panPhoto.split('/')
    : values?.panPhoto;
  const gstImage = values?.gstPhoto
    ? values?.gstPhoto.split('/')
    : values?.gstPhoto;
  const userVerificationDocument = values?.userVerificationDocument
    ? values?.userVerificationDocument.split('/')
    : values?.userVerificationDocument;

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col sm={5} xxl={5} className="mb-2">
          <span className="f-12 text-active fw-medium text-uppercase d-block mb-1">
            Aadhaar Front Image
          </span>
          <span className="f-12 text-drk-525 fw-medium d-block">
            {values?.aadharFront ? (
              <EditUploadDownloadWrapper
                fileName={
                  aadharFrontImage
                    ? aadharFrontImage[aadharFrontImage.length - 1]
                    : aadharFrontImage
                }
                handleDownload={() =>
                  downloadImage(
                    values?.aadharFront,
                    aadharFrontImage
                      ? aadharFrontImage[aadharFrontImage.length - 1]
                      : aadharFrontImage,
                  )
                }
                handleCancel={() => {
                  setFieldValue('aadharFront', '');
                }}
                name="aadharFront"
              />
            ) : (
              <div className="mt-3">
                <S3FileUploadField
                  label=""
                  name="aadharFront"
                  pathUrl="images/aadhar_card/front"
                  accept=".png, .jpg, .jpeg, .pdf"
                />
              </div>
            )}
          </span>
        </Col>
        <Col sm={5} xxl={5} className="mb-2">
          <span className="f-12 text-active fw-medium text-uppercase d-block mb-1">
            Aadhaar Back Image
          </span>
          <span className="f-12 text-dark-525 fw-medium d-block">
            {values?.aadharBack ? (
              <EditUploadDownloadWrapper
                fileName={
                  aadharBackImage
                    ? aadharBackImage[aadharBackImage.length - 1]
                    : aadharBackImage
                }
                handleDownload={() =>
                  downloadImage(
                    values?.aadharBack,
                    aadharBackImage
                      ? aadharBackImage[aadharBackImage.length - 1]
                      : aadharBackImage,
                  )
                }
                handleCancel={() => {
                  setFieldValue('aadharBack', '');
                }}
                // label="Verification Document"
                name="aadharBack"
                accept=".png, .jpg, .jpeg, .pdf"
              />
            ) : (
              <div className="mt-3">
                <S3FileUploadField
                  label=""
                  name="aadharBack"
                  pathUrl="images/aadhar_card/back"
                  accept=".png, .jpg, .jpeg, .pdf"
                />
              </div>
            )}
          </span>
        </Col>
        <Col sm={5} xxl={5} className="mb-2">
          <span className="f-12 text-active fw-medium d-block text-uppercase mb-1">
            Pancard
          </span>
          <span className="f-12 text-dark-525 fw-medium d-block">
            {values.panPhoto ? (
              <EditUploadDownloadWrapper
                fileName={
                  panCardImage
                    ? panCardImage[panCardImage.length - 1]
                    : panCardImage
                }
                handleDownload={() =>
                  downloadImage(
                    values?.panPhoto,
                    panCardImage
                      ? panCardImage[panCardImage.length - 1]
                      : panCardImage,
                  )
                }
                handleCancel={() => {
                  setFieldValue('panPhoto', '');
                }}
                name="panPhoto"
              />
            ) : (
              <div className="mt-3">
                <S3FileUploadField
                  label=""
                  name="panPhoto"
                  pathUrl="images/pan_card"
                  accept=".png, .jpg, .jpeg, .pdf"
                />
              </div>
            )}
          </span>
        </Col>
        <Col sm={5} xxl={5} className="mb-2">
          <span className="f-12 text-active fw-medium d-block text-uppercase mb-1">
            Gst
          </span>
          <span className="f-12 text-dark-525 fw-medium d-block">
            {values.gstPhoto ? (
              <EditUploadDownloadWrapper
                fileName={gstImage ? gstImage[gstImage.length - 1] : gstImage}
                handleDownload={() =>
                  downloadImage(
                    values?.gstPhoto,
                    gstImage ? gstImage[gstImage.length - 1] : gstImage,
                  )
                }
                handleCancel={() => {
                  setFieldValue('gstPhoto', '');
                }}
                name="gstPhoto"
              />
            ) : (
              <div className="mt-3">
                <S3FileUploadField
                  name="gstPhoto"
                  pathUrl="images/gst_certificate"
                  accept=".png, .jpg, .jpeg, .pdf"
                />
              </div>
            )}
          </span>
        </Col>

        <Col sm={5} xxl={5} className="mb-2">
          <span className="f-12 text-active fw-medium d-block text-uppercase mb-1">
            Visiting Card
          </span>
          <span className="f-12 text-dark-525 fw-medium d-block">
            {values.userVerificationDocument ? (
              <EditUploadDownloadWrapper
                fileName={
                  userVerificationDocument
                    ? userVerificationDocument[
                    userVerificationDocument.length - 1
                    ]
                    : userVerificationDocument
                }
                handleDownload={() =>
                  downloadImage(
                    values?.userVerificationDocument,
                    userVerificationDocument
                      ? userVerificationDocument[
                      userVerificationDocument.length - 1
                      ]
                      : userVerificationDocument,
                  )
                }
                handleCancel={() => {
                  setFieldValue('userVerificationDocument', '');
                }}
                name="userVerificationDocument"
                accept=".pdf"
              />
            ) : (
              <div className="mt-3">
                <S3FileUploadField
                  name="userVerificationDocument"
                  pathUrl="images/traders/user_verification_document"
                  accept=".pdf"
                />
              </div>
            )}
          </span>
        </Col>
        <Col sm={10} className="text-end">
          <LoadingButton
            loading={isSubmitting}
            disabled={!isValid || !dirty || isSubmitting}
            color="warning"
            size="sm"
            type="submit"
            className="mw-100 loading-button"
          >
            Update
          </LoadingButton>
        </Col>
      </Row>
    </Form>
  );
};

export default VendorKycForm;
